var storefrontAppDependencies = [
    'pascalprecht.translate', 'ngSanitize'
];

var storefrontApp = angular.module(
    'storefrontApp', storefrontAppDependencies
);

angular.module("storefrontApp").constant("configs",
    (function () {
        if (window.__env) {
            return window.__env;
        }
        else {
            return {
                autoCurrencyConversionCookieName: "AutoCurrencyConversion",
                currencyConverterExcludedUrls: ["/account", "/account/downloads", "/account/myvideos", "/account/orderhistory", "/account/orderreceipt/*", "/giftcard"],
                downloadsPreferredFormatDefinitionNames: ["CustomDigitizing", "Font", "InstantLettering", "ProjectPack", "Software"],
                elasticKey: "gb;9Sq!W>w5;Qh,2",
                freeConversionToolUpdatesCookieName: "FreeConversionToolUpdatesDisabled",
                productTopSellersMinSaleRank: 10,
                freeProductTopSellersMinSaleRank: 100,
                homepageKeys: {
                    projectTutorialsCount: 10,
                    lookBooksCount: 5,
                    digitalEventsCount: 2
                },
                elasticBaseUrl: "https://www.embroiderydesigns.com/es/prdsrch",
                elasticKeywordsBaseUrl: "https://www.embroiderydesigns.com/es/kwsrch",
                projectTutorialsBaseUrl: "https://www.embroiderydesigns.com/embroiderydesigns/sitefiles/LearningCenter/ContributeWorkspace/Articles/Photos/",
                productVideosBaseUrl: "https://vpstaging.embroiderydesigns.com/embroiderydesigns/sitefiles/videos/",
                storePrdImgBaseUrl: "https://img2.embroiderydesigns.com/",
                lookbookImgBaseUrl: "https://www.embroiderydesigns.com/Images/Inspirations/Lookbooks/",
                cdCustomerImagesUrl: "/embroiderydesigns/customdigitizing/customeruploads/",
                cdDigitizerImagesUrl: "/embroiderydesigns/customdigitizing/vendoruploads/",
                customDigitizingProductIds: ["cd1day", "cd2day", "cd3day", "cdover70k", "cdupto50k", "cdupto70k"],
                categoryImageUrl: "https://www.embroiderydesigns.com/images/designs_images/categoryicons/",
                isSiteReleased : true,
                customerInterestIndexThreshold: 5,
                customerInterestIndexMaxThreshold: 25,
            }
        }
    }
)());

storefrontApp.factory('storageFactory', function () {
    return {
        get: function (key) {
            return localStorage.getItem(key);
        },
        set: function (key, data, addExpiryToken) {
            if (addExpiryToken) {
                localStorage.setItem(key, data + "expiry:" + window.currentDate.toString());
            }
            else {
                localStorage.setItem(key, data);
            }
        }
    };
});

storefrontApp.factory('httpErrorInterceptor', ['$q', '$rootScope', function ($q, $rootScope) {
    var httpErrorInterceptor = {};

    httpErrorInterceptor.responseError = function (rejection) {
        if (rejection.data && rejection.data.message) {
            $rootScope.$broadcast('storefrontError', {
                type: 'error',
                title: [rejection.config.method, rejection.config.url, rejection.status, rejection.statusText, rejection.data.message].join(' '),
                message: rejection.data.stackTrace,
            });
        }
        return $q.reject(rejection);
    };
    httpErrorInterceptor.requestError = function (rejection) {
        if (rejection.data && rejection.data.message) {
            $rootScope.$broadcast('storefrontError', {
                type: 'error',
                title: [rejection.config.method, rejection.config.url, rejection.status, rejection.statusText, rejection.data.message].join(' '),
                message: rejection.data.stackTrace,
            });
        }
        return $q.reject(rejection);
    };

    return httpErrorInterceptor;
}]);

storefrontApp.config(['$locationProvider', function ($locationProvider) {
    $locationProvider.hashPrefix('');
}]);

storefrontApp.factory('httpInterceptor', function ($q, $rootScope) {
    var numLoadings = 0;
    return {
        request: function (config) {
            numLoadings++;
            $rootScope.$broadcast("loader_show");
            return config || $q.when(config)
        },
        response: function (response) {
            if ((--numLoadings) === 0) {
                $rootScope.$broadcast("loader_hide");
            }
            return response || $q.when(response);
        },
        responseError: function (response) {
            if (!(--numLoadings)) {
                $rootScope.$broadcast("loader_hide");
            }
            return $q.reject(response);
        }
    }
});

storefrontApp.config(function ($httpProvider) {
    $httpProvider.interceptors.push('httpInterceptor');
});

storefrontApp.factory('cookiesFactory', function () {
    return {
        get: function (key) {
            var cookie = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
            return (cookie ? cookie[2] : null);
        }
    }
});

storefrontApp.controller("recentlyViewedController", [
    "$scope", "recentlyViewedService",
    function ($scope, recentlyViewedService) {
        $scope.updateRecentlyViewed = function (productId) {
            recentlyViewedService.updateRecentlyViewed(productId);
        };
    },
]);
